import * as React from 'react';

// tslint:disable:max-line-length
export const PlayIcon = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 44 44"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>Запустить видео</title>
    <defs>
      <circle id="icon-play-circle" cx="20" cy="20" r="20" />
      <mask id="icon-play-mask" x="-2" y="-2" width="44" height="44">
        <path fill="#fff" d="M-2-2h44v44H-2z" />
        <use xlinkHref="#icon-play-circle" />
      </mask>
    </defs>
    <g transform="translate(2 2)" fill="none" fillRule="evenodd">
      <use stroke="#FFF" mask="url(#icon-play-mask)" strokeWidth="4" xlinkHref="#icon-play-circle" />
      <path fill="#FFF" d="M13.91 29.286V11.953l17.333 8.666z" />
    </g>
  </svg>
);
